import { Accomodation, Place, SinglePageData } from "@/types";

import routeicon from "@/assets/routicon_colored.svg";
import phone from "@/assets/phone_colored.svg";
import global from "@/assets/global-colored.svg";
import owl from "@/assets/owl-colored.svg";
import bubble from "@/assets/bubble.svg";
import InfoBlock from "@/components/InfoBlock";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { tabVariantsAnimation } from "@/theme/theme";

type Type = {
    accomodation: {
        data: SinglePageData;
    };
};

const Info: React.FC<Type> = ({ accomodation, userLatitude, userLongitude }) => {
    const { data } = accomodation;
    // console.log(data);
    const { t } = useTranslation(["common", "validation", "glossary"]);


    return (
        <motion.div
            variants={tabVariantsAnimation}
            animate='animate'
            initial='initial'
            className="space-y-10"
        >

                <div className="flex max-lg:flex-col gap-4 ">
                    {data.content && (
                        <div
                            className="basis-3/5"
                            dangerouslySetInnerHTML={{ __html: data?.content }}
                        />
                    )}
                    <InfoBlock data={data} userLatitude = {userLatitude} userLongitude = {userLongitude}/>
                </div>

                {data.facilities && data.facilities.length > 0 && (
                    <>
                        <div className="flex items-center gap-6">
                            <img src={bubble} />
                            <div className="text-primary font-bold text-4xl">
                                {t("amenities", { ns: "glossary" })}
                            </div>
                            <div className="h-1 w-[120px] mt-2 bg-primary"></div>
                        </div>

                        <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 lg:w-3/4">
                            {data.facilities.map((item, ind) => (
                                <div
                                    key={ind}
                                    className="col-span-1 flex items-center gap-4"
                                >
                                    <div className="h-1 w-6 bg-primary" />
                                    <div> {item.name} </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </motion.div>
            );
};

            export default Info;
